import React from 'react'
import ExpenseRow from './ExpenseRow'

class ExpenseCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null
    };
  }

  handleFocusedInput = (inputId) => {
    this.setState({ focusedInput: inputId });
  };

  handleBlurredInput = () => {
    this.setState({ focusedInput: '' });
  };

  handleExpenses = (propName, expense) => {
    this.props.onChange(propName, expense)
  }

  render() {
    const { focusedInput } = this.state;
    const {
      title,
      id,
      expenses,
      errors,
      values,
      disabled,
      onInvalid,
    } = this.props

    const expenseProps = Object.keys(expenses)

    return (
      <div className='expense card card-single'>
        <div className='expense card-body'>
          <div className='qn'>
            <div className='expense-card-body-title'>
              {title}
            </div>
          </div>
          <div className='expense-card-body-content'>
            <div className='mb-4'>
              { expenseProps.map((propName) => {
                  let iconName = expenses[propName].iconName
                  const value = values[propName]
                  const text = I18n.t(`loan_application_user.expenses.${id}.${iconName}`)

                  return (
                    <ExpenseRow
                      id={id}
                      key={iconName}
                      iconName={iconName}
                      text={ text }
                      errorMessage={ errors[propName] }
                      value={ value }
                      disabled={ disabled }
                      onChange={ (value) => this.handleExpenses(propName, value) }
                      onInvalid={ onInvalid }
                      focusedInput={ this.state.focusedInput }
                      handleFocusedInput={this.handleFocusedInput}
                      handleBlurredInput={this.handleBlurredInput}
                    />
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ExpenseCard
